import { render, staticRenderFns } from "./ParkingLotDetail.vue?vue&type=template&id=18168d36&"
import script from "./ParkingLotDetail.vue?vue&type=script&lang=js&"
export * from "./ParkingLotDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports